import React, { useState, useEffect } from "react";
import { Tab, Tabs } from "@mui/material";
import Workflow from "./KanbanBoard";
import MyPlanner from "../MyPlanner";

function TabsController({ initialTab = "my-planner", onTabChange }) {
  const [currentTab, setCurrentTab] = useState(initialTab);

  // Notify parent component when tab changes
  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
    if (onTabChange) {
      onTabChange(newValue);
    }
  };

  return (
    <>
      <Tabs
        value={currentTab}
        onChange={handleTabChange}
        textColor="primary"
        indicatorColor="primary"
        aria-label="controlled tabs with specific values"
        TabIndicatorProps={{
          className: "tab-indicator",
        }}
        className="tabs-container myPlanner-tabs"
      >
        <Tab
          value="my-planner"
          label="My Planner"
          className={
            currentTab === "my-planner"
              ? "custom-tab-active"
              : currentTab === "my-task"
              ? "custom-tab"
              : "custom-tab before_milestone"
          }
          style={{ ...(currentTab === "my-task" && { border: "0px" }) }}
        />
        <Tab
          value="my-task"
          label="My Tasks"
          className={
            currentTab === "my-task"
              ? "custom-tab-active"
              : currentTab === "my-planner"
              ? "custom-tab"
              : "custom-tab before_milestone"
          }
          style={{ ...(currentTab === "my-planner" && { border: "0px" }) }}
        />
      </Tabs>
      {currentTab === "my-task" && <Workflow />}
      {currentTab === "my-planner" && <MyPlanner />}
    </>
  );
}

export default TabsController;
